export const enum TechpackStatus {

    ASSISTENCE = 'a',
    NO = 'n',
    YES = 'y',

}
